import {createContext, useContext, useReducer} from 'react'
import React from 'react'
import mensdata from '../Datas/mensdata'
import womensdata from '../Datas/womensdata'
import { cartReducer, productReducer } from '../context/reducer'
const Cart = createContext() 
const Contextmen = ({children}) => {

const products = mensdata.mensproductItems
const womenproducts = womensdata.womensproductItems
const [state, dispatch] = useReducer(cartReducer, {
    products : products,
    womenproducts :womenproducts,
    cart : []
})

const [productState, productDispatch] = useReducer(productReducer, {
    searchQuery: "",
  });

  return <Cart.Provider value={{state, dispatch, productState, productDispatch}}>{children}</Cart.Provider>
    
  
}
export const CartState = () =>{
    return useContext(Cart)
}
export default Contextmen
